import { render, staticRenderFns } from "./UserDetailTitle.vue?vue&type=template&id=137e8e47&scoped=true&"
import script from "./UserDetailTitle.vue?vue&type=script&lang=js&"
export * from "./UserDetailTitle.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailTitle.vue?vue&type=style&index=0&id=137e8e47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e8e47",
  null
  
)

export default component.exports